/* eslint-disable @typescript-eslint/no-unused-vars */
import { Doughnut } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend, Title, SubTitle, CategoryScale, LinearScale, BarElement, PointElement, LineElement, ChartData, Plugin, ArcElement as ArcElementType } from 'chart.js';
import { IBaseComponentProps } from '../props/IBaseComponentProps';

ChartJS.register(ArcElement, Tooltip, Legend, Title, SubTitle, CategoryScale, LinearScale, BarElement, PointElement, LineElement);
export interface NSChartDoughnutProps extends IBaseComponentProps
{
	title: string;
	datas: number[];
	labels: string[]
	backgroundColors?: string[];
	borderWidth?: number;
}


export function NSChartDoughnut(props: NSChartDoughnutProps)
{
	let backgroundColors: string[] = [""];
	const options = {
		responsive: true,
		plugins: {
			legend: {
				display: true,
				responsive: true,
				position: 'left' as 'top',
				labels: {
					useBorderRadius: true,
					borderRadius: 100,
					boxWidth: 16,
					color: 'hsla(250, 87%, 29%, 1)',
				},
			},
			title: {
				display: true,
			},
			tooltip: {
				enabled: true,
				titleFont: {
					size: 12
				},
				bodyFont: {
					size: 12
				},
			},
		},
		animation: {
			animateScale: true,
		}
	};

	const generateRandomColor = (): string =>
	{
		let maxVal = 0xFFFFFF;
		let randomNumber: number = Math.random() * maxVal;
		randomNumber = Math.floor(randomNumber);
		let X: string = randomNumber.toString(16);
		let randomColor: string = X.padStart(6, "0");
		return `#${randomColor.toUpperCase()}`
	}

	const setRandomColor = (): string[] =>
	{
		props.datas.forEach(() => backgroundColors?.push(generateRandomColor()))
		return backgroundColors;
	}

	const data: ChartData<'doughnut'> = {
		labels: props.labels,
		datasets: [
			{
				data: props.datas,
				backgroundColor: props.backgroundColors ?? setRandomColor(),
				borderWidth: props.borderWidth ?? 1
			}
		]
	};
	const centerTitlePlugin: Plugin<'doughnut'> = {
		id: 'centerTitle',
		afterDraw(chart)
		{
			const { ctx, chartArea: { width, height } } = chart;
			const meta = chart.getDatasetMeta(0);
			const arc = meta.data[0] as unknown as ArcElementType;
			ctx.save();
			const fontSize = arc.innerRadius / 3;
			ctx.font = fontSize.toString() + "px";
			ctx.fillStyle = 'hsla(234, 64%, 22%, 1)';
			ctx.textBaseline = 'middle';
			ctx.textAlign = 'center';

			const text = props.title;
			const centerX = (arc.x || width / 2);
			const centerY = (arc.y || height / 2);

			ctx.fillText(text, centerX, centerY);
			ctx.restore();
		}
	};
	return (
		<div
			id={props.id}
			className={`${props.classList?.join(" ") ?? ""}`}
			style={props.style}
		>
			<Doughnut
				data={data}
				options={options}
				plugins={[centerTitlePlugin]}
			/>
		</div>
	);
}